import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=5a486bb6&"
import script from "./Countdown.vue?vue&type=script&lang=js&"
export * from "./Countdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a486bb6')) {
      api.createRecord('5a486bb6', component.options)
    } else {
      api.reload('5a486bb6', component.options)
    }
    module.hot.accept("./Countdown.vue?vue&type=template&id=5a486bb6&", function () {
      api.rerender('5a486bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/Countdown.vue"
export default component.exports